
export class AppConstants {
    public static get baseURL(): string {
        return 'https://sunuprojet.sunucloud.com/api/public/';
        //return 'https://preprod.numherit.com/sunuprojet/api/public/';
    }
}


// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/AppConst.ts